import React, { useEffect, useRef } from 'react';

const OpenTableWidget = () => {
  const containerRef = useRef(null);

  useEffect(() => {
    const container = containerRef.current;
    if (!container) return;

    const script = document.createElement('script');
    script.type = 'text/javascript';
    script.src = '//www.opentable.com.au/widget/reservation/loader?rid=56051&type=standard&theme=standard&color=8&dark=false&iframe=true&domain=comau&lang=en-AU&newtab=false&ot_source=Restaurant%20website&font=brandonText&ot_logo=subtle&primary_color=ffffff&primary_font_color=333333&button_color=ed6696&button_font_color=ffffff&logo_pid=87428877&cfe=true';
    script.async = true;

    container.appendChild(script);

    return () => {
      if (container) {
        container.innerHTML = '';
      }
    };
  }, []);

  return <div ref={containerRef} />;
};

export default OpenTableWidget;